<template>
  <div id="contact">
    <div class="container">
      <div class="row">

        <!-- Map -->
        <div class="col-xs-12">
          <div class="row">
            <div id="map"></div>
          </div>
        </div>

        <!-- Form -->
        <div class="col-xs-12 form">
          <div class="row">

            <div class="col-xs-12 col-sm-8">
              <h1>Let’s discuss your next interactive project.</h1>

              <div class="form-group" :class="{ error: errors.includes('name') }">
                <input type="text" class="form-control" placeholder="Name" v-model="message.name" required>
              </div>

              <div class="form-group" :class="{ error: errors.includes('email') }">
                <input type="email" class="form-control" placeholder="Email" v-model="message.email" required>
              </div>

              <div class="form-group" :class="{ error: errors.includes('subject') }">
                <input type="text" class="form-control" placeholder="Subject" v-model="message.subject" required>
              </div>

              <div class="form-group" :class="{ error: errors.includes('message') }">
                <textarea class="form-control" cols="25" rows="10" placeholder="Message" v-model="message.message" required></textarea>
              </div>

              <button type="submit" class="btn btn-default" :disabled="sending" v-text="sending ? 'Sending...' : 'Send'" @click="send()"></button>

              <span class="sent" v-if="sent">Thanks! Your message was sent.</span>

            </div>


            <!-- Contact Info -->
            <div class="col-xs-12 col-sm-4">
              <div class="contact-info">
                <h6>P:
                  <a href="tel:8603503800">860-350-3800</a>
                </h6>

                <address>
                  <h6>33 Bullet Hill Road, Suite 212 <br>
                      Southbury, CT 06488
                  </h6>
                </address>
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="the-office">
                <div v-for="image in officeImages">
                  <img :src="image">
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import 'whatwg-fetch';
  import L from 'leaflet';
  import { requireAll } from 'services/utils';

  const images = require.context('../assets/images/', false, /\.svg$/);

  const EMAIL_RX = /\S+@\S+\.\S+/;
  const OFFICE_COORDS = [41.477331, -73.21485699999999];

  const tileLayer = 'https://api.mapbox.com/styles/v1/mapbox/streets-v10/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic2VhbnBhcjIwMyIsImEiOiJjaXV0M3EyYXcwMGdjMm9zNmdiNmN3anRsIn0.ozdiBBJFz6ER7XZZiXx1nw';

  const icon = L.icon({
    iconUrl:     images('./contact_marker.svg'),
    iconSize:    [55, 100],
    iconAnchor:  [22, 94],
    popupAnchor: [-3, -76],
  });

  const createMap = () => {
    const map = L.map('map').setView(OFFICE_COORDS, 9);

    L.tileLayer(tileLayer).addTo(map);
    L.marker(OFFICE_COORDS, { icon }).addTo(map);
  };

  const INACTIVE = 0;
  const SENDING = 1;
  const SENT = 2;

  export default {

    mounted() {
      createMap();
    },

    data() {
      return {
        message: {
          name:    '',
          email:   '',
          subject: '',
          message: '',
        },
        status: INACTIVE,
        errors: [],
      };
    },

    computed: {

      officeImages() {
        // eslint-disable-next-line global-require, prefer-template, import/no-dynamic-require
        return requireAll(require.context('../assets/images/office', false, /\.jpg$/));
      },

      sending() {
        return this.status === SENDING;
      },

      sent() {
        return this.status === SENT;
      },

    },

    methods: {

      send() {
        if (this.status !== INACTIVE) {
          console.log('pending');
          return;
        }

        if (!this.validate()) {
          console.log('error');
          return;
        }

        this.status = SENDING;

        const body = JSON.stringify(this.message);
        const options = {
          method: 'POST',
          mode:   'no-cors',
          body,
        };

        // eslint-disable-next-line no-undef
        const request = new Request(process.env.MAIL_ENDPOINT, options);

        // eslint-disable-next-line no-undef
        fetch(request)
          .then(() => {
            this.status = SENT;
            this.message = Object.keys(this.message)
              .reduce((acc, key) => ({ ...acc, [key]: '' }), {});

            setTimeout(() => (this.status = INACTIVE), 3500);
          });
      },

      validate() {
        const errors = Object.keys(this.message)
          .filter(field => this.message[field].trim().length === 0);

        if (!EMAIL_RX.test(this.message.email)) {
          errors.push('email');
        }

        this.errors = [...new Set(errors)];

        return this.errors.length === 0;
      },

    },

  };
</script>

<style scoped lang="scss">
  @import "./../../node_modules/leaflet/dist/leaflet.css";

  a {
    color: inherit;
  }

  #contact {
    padding: 75px 0;
  }

  #map {
    margin-top: 50px;
    height: 350px;
  }

  .form {
    margin-top: 50px;
    color: #6E6E6E;
  }

  h1 {
    margin-top: 0;
    margin-bottom: 25px;
    font-size: 28px;
    color: #638E9C;
  }

  .form-control:focus {
    border-color: #638E9C;
    box-shadow: none;
  }

  .btn {
    width: 102px;
    height: 50px;
    color: #FFF;
    font-size: 20px;
    background-color: #F58426;
  }

  .btn:hover {
    background-color: #DB6A0D;
  }

  .contact-info {
    margin-top: 55px;
  }

  .contact-info h6 {
    font-size: 14px;
    font-weight: lighter;
  }

  .the-office {
    margin: 75px 0 25px;

    div {
      float: left;
      margin-right: 55px;

      &:last-child {
        margin-right: 0;
      }
    }

    img {
      max-width: 305px;
      max-height: 230px;
    }
  }

  .sent {
    margin-left: 10px;
  }

  @media (max-width: 767px) {
    #map {
      margin-top: 0;
      height: 275px;
    }

    .the-office {
      margin: 50px 0 0;

      div {
        float: none;
        margin: 0 0 25px;
      }

      img {
        max-width: 100%;
      }
    }
  }

  .error {
    input, textarea {
      border: 1px solid red;
    }
  }
</style>



// WEBPACK FOOTER //
// Contact.vue?726b55ce